import { SxProps, Theme } from '@mui/material';

export const userWelcomeContainerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
};

export const userAvatarContainerSx: SxProps<Theme> = {
  cursor: 'pointer',
  borderRadius: '4px',
};

export const avatarSx = (darkMode: boolean) => ({
  width: 24,
  height: 24,
  fontSize: 'small',
  bgcolor: 'primary.main',
  color: darkMode ? 'primary' : 'text.primary',
});

export const menuPaperSx: SxProps<Theme> = {
  width: 320,
  maxHeight: '80vh',
  overflow: 'auto',
};

export const userInfoSectionSx: SxProps<Theme> = {
  p: 2,
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const userNameSx: SxProps<Theme> = {
  fontWeight: 'bold',
  mb: 0.5,
};

export const userEmailSx: SxProps<Theme> = {
  color: 'text.secondary',
};

export const iconSx: SxProps<Theme> = {
  ml: 0.5,
  verticalAlign: 'text-bottom',
};

export const companySectionSx: SxProps<Theme> = {
  p: 2,
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const companyRoleLabelSx: SxProps<Theme> = {
  mb: 1,
};

export const rolesContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 0.5,
};

export const sectionBoxSx: SxProps<Theme> = {
  py: 2,
  pl: 1.5,
  pr: 2,
  borderBottom: '1px solid',
  borderColor: 'divider',
};

export const formControlSx: SxProps<Theme> = {
  margin: 0,
};

export const menuItemSx: SxProps<Theme> = {
  py: 1.5,
};

// Lines the icon up with Logout's, which sits inside an IconButton's 8px padding
export const menuItemIconSx: SxProps<Theme> = {
  color: 'action.active',
  mx: 1,
};
